import { useLang } from "@/context/LanguageContext";
import { LEGAL } from "@/data/seo";
import { Reveal } from "@/components/Shared";

const LegalPage = ({ kind }) => {
  const { lang } = useLang();
  const doc = LEGAL[lang][kind];
  return (
    <article data-testid={`legal-page-${kind}`} className="relative px-6 pb-24 pt-40 sm:px-12 sm:pt-48 lg:px-20">
      <Reveal y={20}>
        <h1 className="break-words font-serif text-4xl font-light leading-[0.95] text-[#F9F8F6] [hyphens:auto] sm:text-6xl lg:text-7xl">{doc.title}</h1>
        {doc.updated && <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.3em] text-[#71717A]">{doc.updated}</p>}
      </Reveal>
      <div className="mt-16 max-w-3xl space-y-12">
        {doc.sections.map((s) => (
          <Reveal key={s.h} y={16}>
            <section>
              <h2 className="font-serif text-2xl font-light text-[#C5A059]">{s.h}</h2>
              <div className="mt-4 space-y-3">
                {s.p.map((p, i) => (
                  <p key={i} className={`break-words font-sans text-sm leading-loose ${p.includes("[") ? "text-[#E5C158]" : "text-[#A1A1AA]"}`}>{p}</p>
                ))}
              </div>
            </section>
          </Reveal>
        ))}
      </div>
    </article>
  );
};

export const ImprintPage = () => <LegalPage kind="imprint" />;
export const PrivacyPage = () => <LegalPage kind="privacy" />;
export default LegalPage;
